export default __webpack_public_path__ + "static/media/2408024.1905f748.webp";